/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';
import NextLink from 'next/link';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './TopicAside.module.scss';

import { topicPath } from '../../paths';
import type { TopicAsideProps } from './TopicAside.types';

const PRODUCT_LABELS: Record<string, string> = {
  '/api': 'Company data API',
  '/kyb-verification': 'Business verification',
  '/business-credit-risk': 'Business credit risk',
  '/enrichment': 'Data enrichment',
};

export const TopicAside = ({ related, product, lang, className }: TopicAsideProps) => {
  const { t } = useInt();

  return (
    <aside className={cn(styles['aside'], className)}>
      {related.length > 0 && (
        <div className={styles['card']}>
          <p className={styles['title']}>{t('The next question')}</p>

          <ul className={styles['list']}>
            {related.map((link) => (
              <li key={link.slug}>
                <NextLink href={topicPath(link.slug, lang)} className={styles['link']}>
                  {link.name}
                  <Icon type="arrow-10" className={styles['chevron']} />
                </NextLink>
              </li>
            ))}
          </ul>
        </div>
      )}

      {product && (
        <div className={styles['cta']}>
          <p className={styles['ctaTitle']}>{t('Put the evidence in context.')}</p>

          <p className={styles['ctaText']}>{t('See the registry record behind every answer.')}</p>

          <Button type="white" size="md" width="100%" href={product}>
            {t(PRODUCT_LABELS[product] ?? 'Global Database')}
          </Button>
        </div>
      )}
    </aside>
  );
};
